import React, { FC } from 'react'
import { useFlowContext } from '../../../hooks'

export const SessionContainer: FC = ({ children }) => {
  const flowContext = useFlowContext()
  const { Session } = flowContext.getComponents()

  return <Session>{children}</Session>
}
